<template>
  <div id="menu-promo-container">
    <div id="menu-promo" class="titre d-flex">
      <button
        id="menu-promo-en-cours"
        :class="isArchive ? 'inactive' : 'active'"
        @click="showPromoArchive(false)"
      >
        {{ $t('messageComponent.promoEnCours') }}
      </button>
      <button
        id="menu-promo-archives"
        :class="isArchive ? 'active' : 'inactive'"
        @click="showPromoArchive(true)"
      >
        {{ $t('messageComponent.promoTerminees') }}
      </button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'MenuPromotions',
  props: { metadata: { type: Object, required: true }, content: { type: Object, required: true } },
  i18n: {
    messages: {
      fr: {
        messageComponent: {
          promoEnCours: 'Promotions en cours',
          promoTerminees: 'Gagnants et promotions terminées',
        },
      },
      en: {
        messageComponent: {
          promoEnCours: 'Current Promos',
          promoTerminees: 'Winners and Past Promos',
        },
      },
    },
  },
  data() {
    return {
      isArchive: false,
    };
  },
  mounted() {
    if (this.$route.query.section == 'gagnants') {
      this.showPromoArchive(true);
    }
  },
  methods: {
    showPromoArchive(active) {
      this.isArchive = active;
      this.$store.commit('menu/SET_IS_ARCHIVE_MODE', active);
    },
  },
};
</script>

<style lang="scss" scoped>
#menu-promo-container {
  height: 110px;
  background-color: #ebebeb;
  font-size: 28px;
  color: #525252;
  font-weight: 200;
}

#menu-promo {
  max-width: 1280px;
  margin: 0 auto;
  padding-top: 0;
  height: 100%;
  padding-bottom: 0;
}

#menu-promo button {
  border: none;
  width: 50%;
  color: #4e4e4e;
  background-color: #ebebeb;
}

#menu-promo .active {
  color: #005ac1 !important;
  border-top: 12px solid #005ac1;
}
</style>
